import React from 'react'; // eslint-disable-line
import AlertLoader from '../../containers/alerts/AlertLoader';
import BannerLoader from '../../containers/alerts/BannerLoader';

const VersionFree = (props) => {
    return (
        <div className="main">
            <div className="main-inner">
                <div className="content-wrap">
                    <AlertLoader />
                    <div className={`content-inside-wrap ${props.alerts.data.filter((alert) => { return alert.type === 'banner'; }).length > 0 ? 'banner' : ''}`}>
                        <BannerLoader alerts={props.alerts} />
                        <div className="content-inside content-children">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VersionFree;
